import Login from '../../containers/auth/Login';
import CreatePassword from '../../containers/auth/CreatePassword';
import ForgotPassword from '../../containers/auth/ForgotPassword';
import ResetPassword from '../../containers/auth/ResetPassword';
import PATH from '../paths';

export const LOGIN = {
  component: Login,
  path: PATH.AUTH.LOGIN,
  exact: true,
  isProtected: false,
};

export const CREATE_PASSWORD = {
  component: CreatePassword,
  path: PATH.AUTH.CREATE_PASSWORD,
  exact: true,
  isProtected: true,
};

export const FORGOT_PASSWORD = {
  component: ForgotPassword,
  path: PATH.AUTH.FORGOT_PASSWORD,
  exact: true,
  isProtected: false,
};

export const RESET_PASSWORD = {
  component: ResetPassword,
  path: PATH.AUTH.RESET_PASSWORD,
  exact: true,
  isProtected: false,
};

export default [LOGIN, CREATE_PASSWORD, FORGOT_PASSWORD, RESET_PASSWORD];
